import { render, staticRenderFns } from "./tema-dark.vue?vue&type=template&id=00e3027d&scoped=true&"
import script from "./tema-dark.vue?vue&type=script&lang=js&"
export * from "./tema-dark.vue?vue&type=script&lang=js&"
import style0 from "./tema-dark.vue?vue&type=style&index=0&id=00e3027d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e3027d",
  null
  
)

export default component.exports